import { combineReducers } from 'redux';
import performance from './performance';
import transactions from './transactions';
import salesFilters from './salesFilters';
import managerSales from './managerSales';
import associateScorecard from './associateScorecard';
import associateEngagements from './associateEngagements';
import expandedScorecard from './expandedScorecard';
import reminders from './reminders';

const appReducer = combineReducers({
  performance,
  transactions,
  salesFilters,
  managerSales,
  associateScorecard,
  associateEngagements,
  reminders,
  expandedScorecard,
});

export default (state, action) => appReducer(state, action);
